import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512.000000 512.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3672 4168 l3 -42 73 -13 c111 -18 164 -39 234 -92 99 -75 159 -157
197 -270 18 -51 22 -84 20 -168 -1 -57 0 -106 2 -108 2 -2 20 -6 40 -10 34 -6
37 -5 43 20 13 50 7 192 -9 257 -42 160 -165 319 -307 393 -73 39 -199 75
-260 75 l-39 0 3 -42z"
          />
          <path
            d="M3683 4020 c4 -18 7 -39 7 -46 0 -10 13 -14 40 -14 50 0 111 -24 176
-69 92 -63 143 -168 144 -293 l0 -76 36 -12 c47 -16 54 -6 54 86 0 178 -97
333 -259 411 -52 25 -92 37 -139 41 l-65 5 6 -33z"
          />
          <path
            d="M3695 3878 c-3 -7 -1 -26 3 -43 6 -22 16 -31 39 -36 42 -8 84 -36
119 -78 23 -27 30 -48 34 -95 5 -59 6 -61 43 -75 20 -7 40 -11 43 -8 3 3 5 33
5 66 0 75 -24 134 -81 195 -59 63 -191 111 -205 74z"
          />
          <path
            d="M3685 3718 c-32 -19 -44 -41 -45 -81 0 -31 7 -46 34 -73 44 -44 86
-46 127 -5 46 46 35 115 -23 151 -37 22 -64 25 -93 8z"
          />
          <path
            d="M1367 3543 c-4 -3 -7 -456 -7 -1005 l0 -998 230 0 230 0 0 454 c0
261 4 457 9 460 5 4 23 -27 39 -66 17 -40 51 -117 76 -170 25 -53 46 -99 46
-102 0 -3 18 -44 40 -93 22 -48 55 -120 73 -160 17 -40 37 -72 44 -73 7 0 26
30 44 68 24 53 154 343 199 447 5 11 40 85 78 165 38 80 95 201 127 270 31 69
77 169 103 223 l46 97 443 0 443 0 0 238 0 239 -572 7 c-462 6 -574 4 -584 -6
-7 -7 -51 -101 -99 -208 -48 -107 -97 -217 -110 -245 -12 -27 -42 -94 -65
-148 -24 -54 -48 -96 -53 -94 -9 3 -72 136 -151 318 -76 174 -170 375 -180
381 -14 10 -440 10 -449 1z"
          />
          <path
            d="M2943 2784 c-11 -16 -61 -99 -112 -184 -51 -85 -106 -177 -122 -203
-16 -27 -29 -55 -29 -62 0 -31 97 -47 309 -52 l203 -6 33 -29 c55 -48 55 -100
-2 -156 -27 -27 -85 -32 -388 -32 l-310 0 -123 -245 c-67 -135 -122 -252 -122
-260 0 -13 61 -15 479 -15 278 0 501 4 532 10 232 43 435 243 484 475 62 294
-73 591 -326 716 -100 50 -150 60 -325 66 l-161 6 -20 -29z"
          />
          <path
            d="M1925 1443 c-11 -3 -32 -17 -47 -31 -22 -20 -28 -35 -28 -68 0 -36 5
-47 35 -73 20 -17 44 -31 55 -31 26 0 73 19 82 33 5 8 10 5 14 -10 8 -30 48
-25 52 5 3 17 10 22 33 22 24 0 29 -4 29 -24 0 -19 5 -23 26 -23 23 0 25 3 22
36 l-3 36 -67 -1 c-38 0 -68 3 -68 8 0 4 32 8 70 8 l70 0 0 60 c0 71 -17 81
-23 13 l-3 -48 -2 48 c-2 61 -22 53 -22 -9 0 -42 -1 -44 -29 -44 -28 0 -30 2
-33 47 -2 29 -8 48 -17 51 -8 3 -11 0 -7 -6 4 -6 -2 -8 -16 -4 -14 3 -19 2
-14 -6 9 -15 6 -15 -37 3 -38 16 -39 16 -72 8z m113 -102 c3 -46 1 -51 -17
-51 -11 0 -23 -4 -26 -10 -3 -5 -14 -10 -23 -9 -12 0 -11 3 6 9 12 5 22 14 22
20 0 13 -6 13 -31 -1 -45 -24 -93 48 -54 81 9 8 29 10 51 7 28 -5 35 -3 30 8
-4 11 0 12 17 6 18 -7 23 -17 25 -60z m-161 -13 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z"
          />
          <path
            d="M2220 1345 c0 -63 4 -105 10 -105 6 0 10 42 10 105 0 63 -4 105 -10
105 -6 0 -10 -42 -10 -105z"
          />
          <path
            d="M2250 1346 c0 -64 4 -106 10 -106 6 0 10 40 10 99 0 56 -4 103 -10
106 -6 4 -10 -32 -10 -99z"
          />
          <path
            d="M2300 1348 l0 -105 25 0 c16 0 30 8 37 20 10 20 11 20 29 -4 15 -19
21 -21 28 -10 7 11 9 11 13 0 3 -8 9 -11 13 -7 5 5 -2 28 -15 53 l-24 46 22
45 c26 53 28 72 7 54 -10 -9 -15 -9 -15 -1 0 25 -21 8 -44 -36 l-25 -48 -1 43
c0 69 -20 48 -22 -25 l-2 -68 -3 65 c-7 110 -23 95 -23 -22z m101 39 c-10 -9
-11 -8 -5 6 3 10 9 15 12 12 3 -3 0 -11 -7 -18z m-48 -92 c-3 -9 -8 -14 -10
-11 -3 3 -2 9 2 15 9 16 15 13 8 -4z"
          />
          <path
            d="M2748 1439 c-54 -20 -47 -79 13 -106 21 -10 39 -24 39 -30 0 -16 -15
-16 -41 -3 -15 8 -23 7 -34 -4 -21 -21 -19 -25 21 -42 43 -18 88 -11 107 17
14 19 14 19 31 0 38 -42 113 -34 135 15 14 31 15 164 1 164 -6 0 -11 -34 -12
-77 l-2 -78 -3 73 c-5 88 -23 96 -23 9 0 -67 -10 -88 -41 -80 -16 5 -19 15
-19 74 0 39 -4 70 -10 70 -44 6 -45 5 -50 -56 -3 -35 -8 -53 -12 -43 -4 9 -23
22 -42 29 -37 14 -51 35 -16 26 10 -3 27 1 36 7 15 12 15 14 -7 29 -26 19 -33
20 -71 6z m20 -76 c9 -7 11 -13 5 -13 -11 0 -43 27 -43 35 0 2 3 12 7 22 7 15
8 15 11 -7 2 -14 11 -31 20 -37z m70 -63 c-2 -16 -10 -26 -23 -28 -18 -2 -18
-2 -2 8 9 6 17 16 17 22 0 6 -8 20 -17 31 -18 19 -17 19 5 6 16 -10 22 -22 20
-39z m87 -28 c-3 -3 -11 0 -18 7 -9 10 -8 11 6 5 10 -3 15 -9 12 -12z m65 13
c0 -2 -10 -9 -22 -15 -22 -11 -22 -10 -4 4 21 17 26 19 26 11z"
          />
          <path
            d="M3040 1345 l0 -105 49 0 c94 0 129 32 111 101 -5 19 -11 46 -14 60
-7 32 -42 49 -101 49 l-45 0 0 -105z m27 43 c-3 -7 -5 -2 -5 12 0 14 2 19 5
13 2 -7 2 -19 0 -25z m103 -7 c-1 -13 -3 -13 -15 3 -19 26 -19 42 0 26 8 -7
15 -20 15 -29z m-40 4 c0 -8 -9 -15 -20 -15 -11 0 -20 7 -20 15 0 8 9 15 20
15 11 0 20 -7 20 -15z m45 -76 c0 -26 -5 -35 -20 -37 -20 -4 -20 -4 0 11 17
13 18 18 7 42 -10 21 -10 26 0 23 7 -3 13 -20 13 -39z m-108 -21 c-3 -7 -5 -2
-5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m81 20 c-7 -20 -58 -23 -58 -4 0 11
10 16 31 16 20 0 29 -4 27 -12z"
          />
          <path
            d="M3524 1376 c-1 -70 1 -76 20 -77 20 0 20 -1 -1 -9 -13 -5 -23 -15
-23 -22 0 -8 -5 -6 -11 5 -5 9 -20 17 -32 17 -17 0 -19 2 -8 9 12 8 9 18 -13
63 -47 89 -46 89 -103 -14 -29 -51 -50 -95 -47 -97 2 -2 15 8 28 22 31 34 42
35 20 2 -10 -15 -12 -25 -5 -25 6 0 11 5 11 10 0 12 87 13 94 1 3 -5 30 -8 61
-8 30 0 55 3 55 8 0 5 12 9 28 9 26 0 69 22 85 44 11 16 25 -11 20 -38 -4 -20
-1 -23 21 -23 14 0 26 3 26 7 0 4 18 10 39 14 28 4 46 15 60 35 26 36 26 57 2
97 -20 32 -51 44 -117 44 -30 0 -34 -3 -34 -25 0 -31 -7 -31 -37 -3 -17 16
-39 23 -81 26 l-57 4 -1 -76z m139 22 c24 -28 21 -55 -8 -83 -17 -18 -34 -25
-57 -23 l-33 1 33 4 c68 9 81 86 20 117 l-33 17 30 -6 c17 -3 38 -15 48 -27z
m167 12 c43 -43 11 -121 -47 -119 -21 1 -23 2 -8 6 30 8 55 33 55 58 0 35 -24
58 -71 65 l-44 7 48 2 c35 1 52 -4 67 -19z m-283 -12 c-3 -8 -6 -5 -6 6 -1 11
2 17 5 13 3 -3 4 -12 1 -19z m-113 -34 c9 -20 15 -39 12 -42 -3 -2 -11 7 -17
22 -15 33 -20 33 -41 -1 -10 -16 -18 -22 -18 -15 0 16 31 72 40 72 4 0 14 -16
24 -36z m200 14 c15 -25 -3 -52 -38 -56 -24 -3 -26 -1 -26 38 0 39 2 41 26 38
15 -2 32 -11 38 -20z m175 0 c12 -31 -4 -58 -33 -58 -18 0 -25 6 -28 28 -6 41
0 52 28 52 16 0 28 -8 33 -22z m-262 -45 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18
2 -10 2 -26 0 -35z"
          />
          <path
            d="M1390 1343 c0 -62 4 -103 10 -103 6 0 10 31 10 72 0 39 3 68 7 65 3
-4 5 -36 4 -72 -2 -41 2 -65 8 -65 6 0 11 17 11 38 l1 37 24 -28 c14 -16 30
-25 35 -22 6 4 8 11 5 16 -3 5 1 6 9 3 9 -4 18 1 22 10 10 27 22 18 20 -16 -1
-29 2 -33 24 -33 25 0 25 1 28 98 2 58 -1 97 -7 97 -5 0 -29 -22 -52 -50 -23
-27 -46 -50 -50 -50 -4 0 -30 24 -58 53 l-51 52 0 -102z m180 23 c0 -2 -8 -10
-17 -17 -16 -13 -17 -12 -4 4 13 16 21 21 21 13z"
          />
          <path
            d="M1702 1408 c-36 -61 -82 -149 -82 -159 0 -18 17 -8 29 17 6 15 14 24
18 21 3 -4 0 -13 -6 -21 -7 -8 -8 -17 -3 -20 6 -3 15 1 22 9 14 17 80 17 86 0
7 -16 64 -15 64 1 0 7 -4 15 -8 18 -5 3 -26 39 -47 81 -22 42 -42 78 -46 81
-4 2 -16 -11 -27 -28z m57 -78 c0 -8 -7 -2 -16 14 l-15 29 -20 -24 -19 -24 17
34 16 34 19 -24 c10 -13 18 -31 18 -39z"
          />
          <path
            d="M2528 1350 c-53 -98 -61 -131 -22 -85 20 23 23 25 14 7 -15 -30 -5
-40 18 -19 22 20 55 22 85 5 21 -11 67 -20 67 -13 0 9 -104 195 -109 195 -3 0
-27 -41 -53 -90z m75 11 c9 -16 17 -33 17 -38 -1 -4 -8 4 -16 20 -18 32 -30
34 -39 6 -4 -11 -9 -18 -11 -16 -6 6 17 57 25 57 4 0 14 -13 24 -29z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
